var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resultStatus resultCompleted full-width full-height flex column justify-center text-center q-px-lg"},[(
      _vm.serviceTypeStatus === 'DELIVERY' &&
        [
          200,
          300,
          400,
          500,
          600,
          610,
          620,
          630,
          700,
          800,
          900,
          1000,
          1010,
          1020,
          1030,
          1040,
          1080
        ].includes(_vm.shipmentStatusCode)
    )?_c('div',[_c('div',{staticClass:"title font-size-20 text-weight-bolder statuscode-box"},[_c('div',[_c('strong',{domProps:{"innerHTML":_vm._s(_vm.orderMsgs.status)}})]),_c('div',[_c('strong',[_vm._v(" "+_vm._s(_vm.orderMsgs.Driver))])]),_c('div',[_c('strong',[_vm._v(" "+_vm._s(_vm.orderMsgs.Seller))])])]),_c('div',{staticClass:"YourMeal-box"},[(
          _vm.serviceTypeStatus === 'DELIVERY' &&
            [
              200,
              300,
              400,
              500,
              600,
              610,
              620,
              630,
              700,
              800,
              900,
              1000,
              1010,
              1020,
              1030,
              1040,
              1080
            ].includes(_vm.shipmentStatusCode)
        )?_c('div',{staticClass:"desc font-size-16 text-theme-gray q-my-sm statuscode-value"},[_c('span',[_vm._v(" "+_vm._s(_vm.orderMsgs.value))])]):_vm._e(),([900].includes(_vm.shipmentStatusCode))?_c('div',{staticClass:"desc font-size-16 text-theme-gray q-my-sm CourierInfo"},[_c('span',[_vm._v(" "+_vm._s(_vm.orderMsgs.CourierInfo))])]):_vm._e(),([700, 800].includes(_vm.shipmentStatusCode))?_c('div',{staticClass:"desc font-size-16 text-theme-gray q-my-sm CourierInfo"},[_c('span',[_vm._v(" "+_vm._s(_vm.orderMsgs.CourierInfo))])]):_vm._e(),([700, 800].includes(_vm.shipmentStatusCode))?_c('div',{staticClass:"desc text-theme-gray q-my-sm GKNumber"},[_c('span',[_vm._v(" "+_vm._s(_vm.shipmentExternalId))])]):_vm._e()]),_c('div',{staticClass:"CheckDetails"},[_c('span',{on:{"click":_vm.alterCheck}},[_vm._v(_vm._s(_vm.$t('result.showDetilStatus1')))]),_c('span',{staticClass:"iconfont"},[_vm._v("")])])]):_vm._e(),(_vm.serviceTypeStatus !== 'DELIVERY')?_c('div',[_c('div',{staticClass:"title font-size-24 text-weight-bolder"},[_vm._v("\n      "+_vm._s(_vm.detail.serviceType === 'DINE_IN'
          ? _vm.$t('result.completedTitle1')
          : _vm.$t('result.completedTitle2'))+"\n    ")]),_c('div',{staticClass:"desc font-size-12 text-theme-gray q-my-sm"},[_vm._v("\n      "+_vm._s(_vm.detail.serviceType === 'DINE_IN'
          ? _vm.$t('result.completedDesc1', [_vm.table])
          : _vm.$t('result.completedDesc2'))+"\n    ")])]):_vm._e(),_c('Popup',{attrs:{"service-type":_vm.serviceTypeStatus},on:{"setPopupChild":_vm.setPopupChild}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }